
<!-- /******************************************************************************************* -->
<mat-toolbar class="toolbar">
    <span class="toolbar-text">Select Configuration Settings</span>
  <button mat-icon-button aria-label="close dialog" mat-dialog-close class="margin-auto">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<div class="gridSize" *ngIf="!fromTable">
  <div class="grid-style">
    <div class="csh-text">
      <div class="headerText">{{headername}}</div>
    </div>
    <div class="searchBox">
      <input class="inputBox" placeholder="Search"  type="search" placeholder="Search" [(ngModel)]="searchValueA" (input)="searchOnInput($event.target.value,1)">
      <i class="fa fa-search" style="color:rgba(0,0,0,.87); cursor:pointer;" (click)="search(1,searchValueA)"  aria-hidden="true"></i>
    </div>

    <div class="checkOptions" style="text-align: center; margin-top: 100px; font-weight: normal" *ngIf="selectedOptions?.length==0">
      <div>
        <img src="./assets/Not Found.svg" alt="Not-Found">
        <p style="font-size: 26px;color: #333333; margin-top: 10px;">No Items!</p>
      </div>
    </div>

    <div class="checkOptions" *ngIf="selectedOptions?.length!=0">
      <mat-checkbox type="checkbox" name="list_name" disabled="true" value="h1" (click)="deselectAll()">
        <span style="color:#333333">De-select all</span>
      </mat-checkbox>
    </div>
    <div *ngIf="selectedOptions?.length!=0">
      <div class="options">
        <mat-checkbox class="example-radio-button" style="display: block;"
          *ngFor="let data of selectedOptions; let i=index" checked="true"
          (change)="removeOptions($event.checked,i,data)" class="textFormat">
          {{data.TASK_NAME}}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="grid-style" style="margin-left: 30px;">
    <div class="csh-text">
      <div class="headerText">Removed from {{headername}}</div>
    </div>
    <div class="searchBox">
      <input class="inputBox" type="search" placeholder="Search" [(ngModel)]="searchValueB" (input)="searchOnInput($event.target.value,2)">
      <i class="fa fa-search" style="color:rgba(0,0,0,.87); cursor:pointer;" (click)="search(2,searchValueB)"  aria-hidden="true"></i>
    </div>

    <div class="checkOptions" style="text-align: center; margin-top: 100px; font-weight: normal"
      *ngIf="removedOptions?.length==0">
      <div>
        <img src="./assets/Not Found.svg" alt="Not-Found">
        <p style="font-size: 26px;color: #333333; margin-top: 10px;">No Items!</p>
      </div>
    </div>
    <div class="checkOptions" *ngIf="removedOptions?.length!=0">
      <mat-checkbox name="list_name" value="h2" style="cursor: pointer;"  disabled="true" (click)="selectAll()"><span style="color:#333333">Select all</span></mat-checkbox>
    </div>
    <div *ngIf="removedOptions?.length!=0">
      <div class="options">
        <mat-checkbox class="example-radio-button" style="display: block;"
          *ngFor="let option of removedOptions; let i=index" (change)="checkedOptionstoAdd($event.checked,i,option)">
          {{option.TASK_NAME}}
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>

 <!-- /******************************************************************************************* -->
<div class="gridSize" *ngIf="fromTable">
  <div class="grid-style">
    <div class="csh-text">
      <div class="headerText">{{headername}}</div>
    </div>
    <div class="searchBox">
      <input class="inputBox"  type="search" placeholder="Search" [(ngModel)]="searchValueA" (input)="searchOnInput($event.target.value,1)">
      <i class="fa fa-search" style="color:rgba(0,0,0,.87); cursor:pointer;" (click)="search(1,searchValueA)"  aria-hidden="true"></i>
    </div>

    <div class="checkOptions" style="text-align: center; margin-top: 100px; font-weight: normal" *ngIf="selectedOptions?.length==0">
      <div>
        <img src="./assets/Not Found.svg" alt="Not-Found">
        <p style="font-size: 26px;color: #333333; margin-top: 10px;">No Items!</p>
      </div>
    </div>

    <div class="checkOptions" *ngIf="selectedOptions?.length!=0">
      <mat-checkbox type="checkbox" style="cursor: pointer;" name="list_name" value="h1" disabled="true" (click)="deselectAllEdit()">
        <span style="color:#333333">De-select all</span>
      </mat-checkbox>
    </div>
    <div *ngIf="selectedOptions?.length!=0">
      <div class="options">
        <mat-checkbox class="example-radio-button" style="display: block;"
          *ngFor="let data of selectedOptions; let i=index" checked="true"
          (change)="removeOptionsEdit($event.checked,i,data)" class="textFormat">
          {{data.taskname}}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="grid-style" style="margin-left: 30px;">
    <div class="csh-text">
      <div class="headerText">Removed from {{headername}}</div>
    </div>
    <div class="searchBox">
      <input class="inputBox" type="search" placeholder="Search" [(ngModel)]="searchValueB" (input)="searchOnInput($event.target.value,2)">
      <i class="fa fa-search" style="color:rgba(0,0,0,.87); cursor:pointer;" (click)="search(2,searchValueB)"  aria-hidden="true"></i>
    </div>

    <div class="checkOptions" style="text-align: center; margin-top: 100px; font-weight: normal"
      *ngIf="removedOptions?.length==0">
      <div>
        <img src="./assets/Not Found.svg" alt="Not-Found">
        <p style="font-size: 26px;color: #333333; margin-top: 10px;">No Items!</p>
      </div>
    </div>
    <div class="checkOptions" *ngIf="removedOptions?.length!=0">
      <mat-checkbox name="list_name" value="h2" style="cursor: pointer;"  disabled="true" (click)="selectAllEdit()"><span style="color:#333333">Select all</span></mat-checkbox>
    </div>
    <div *ngIf="removedOptions?.length!=0">
      <div class="options">
        <mat-checkbox class="example-radio-button" style="display: block;"
          *ngFor="let option of removedOptions; let i=index" (change)="checkedOptionstoAddEdit($event.checked,i,option)">
          {{option.taskname}}
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>
<!-- /******************************************************************************************* -->

<div class="" style="margin-top: 24px;margin-left: 15px">
  <button mat-flat-button class="cancelButton r-m12" (click)="onCancel()"> Cancel</button>
  <button mat-flat-button class="green-button l-m12" style="margin-right: 15px;" (click)="saveOptions()"> Save
    Configurations </button>
</div>




